import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { corporationGroupId, kuitanAgentGroupId, managerGroupId, restaurantGroupId, salesmanGroupId } from '../../groupNumber';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalCloseButton,
  useDisclosure,
  Button,
  Box,
} from '@chakra-ui/react'
import { useFetchUser } from '../../hooks/user/useFetchUser';


export const LogoutModal: React.FC = () => {
  const {user} = useFetchUser()
  const { isOpen, onOpen, onClose } = useDisclosure()
  const groupToPath: { [key: number]: string } = {
    [salesmanGroupId]: '/salesman-login',
    [corporationGroupId]: '/corporation-login',
    [restaurantGroupId]: '/restaurant-login',
    [managerGroupId]: '/login/manager',
    [kuitanAgentGroupId]: '/login/kuitan-agent',
  };
  const path = user?.groups?.map(group => groupToPath[group]).find(path => path) || '/';
  const navigate = useNavigate();
  const logout = useCallback(() => {
    // iframeを使って別ドメインのログアウト処理を実行
    const iframe = document.createElement('iframe');
    iframe.style.display = 'none';
    iframe.src = `${process.env.REACT_APP_RESERVE_BASE_URL}/shop_manager/blocks_logout`; // 環境変数などで base URL を管理
    document.body.appendChild(iframe);

    // iframeの読み込み完了後に現在のアプリ側のログアウトを実行
    iframe.onload = () => {
      localStorage.clear();
      navigate(path);
    };

    // 安全のために 3 秒後には fallback で強制ログアウト（onload が発火しない場合）
    setTimeout(() => {
      localStorage.clear();
      navigate(path);
    }, 3000);
  }, [path, navigate]);
  return (
    <>
      <Box fontSize={{base: 'xs', sm: 'sm'}} color='white' cursor='pointer' onClick={onOpen}>ログアウト</Box>
      <Modal isOpen={isOpen} onClose={onClose} size='xs'>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader pb='0'>ログアウトしますか？</ModalHeader>
          <ModalCloseButton />
          <ModalFooter>
            <Button colorScheme="blue" size='sm' mr={3} onClick={logout}>
              はい
            </Button>
            <Button variant='ghost' size='sm' onClick={onClose}>いいえ</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};